import { render, staticRenderFns } from "./CrmShell.vue?vue&type=template&id=45003ad3&scoped=true"
import script from "./CrmShell.vue?vue&type=script&lang=js"
export * from "./CrmShell.vue?vue&type=script&lang=js"
import style0 from "./CrmShell.vue?vue&type=style&index=0&id=45003ad3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45003ad3",
  null
  
)

export default component.exports